<template>
    <div>
        <v-card-title>
            Vereine für Testspiele verwalten
        </v-card-title>
        <v-card-subtitle>
            nur verfügbar in den Nationalen Ligen
        </v-card-subtitle>
        <div class="px-5">
            <v-btn class="mr-5" color="primary" @click="editVerein(null)">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Neuen Verein anlegen
            </v-btn>
            <v-btn v-if="$vuetify.breakpoint.mdAndUp" @click="back()">
                <v-icon class="mr-2">mdi-arrow-left</v-icon>
                Zurück zur nationalen Liga
            </v-btn>
            <v-btn v-if="$vuetify.breakpoint.xsOnly" fab dark bottom right
                   color="primary" class="backButtonMob" @click="back()">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-list :class="[{'listSmall': $vuetify.breakpoint.smAndUp}, 'ml-3 mt-2']">
                <v-list-item v-for="(verein, i) in vereine" :key="i" class="pl-1 pr-0">
                    <span class="text-truncate">
                        {{verein.id}} / {{verein.name}}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="editVerein(verein.id)"><v-icon>mdi-pencil</v-icon></v-btn>
                    <dummy-vereine-delete :item="verein"></dummy-vereine-delete>
                </v-list-item>
            </v-list>
        </div>
        <dummy-vereine-edit v-if="$route.query.action==='dummyVereineEdit'"
                            :currentObject="currentObject">
        </dummy-vereine-edit>
    </div>
</template>

<script>
    import DummyVereineEdit from "./dummyVereineEdit";
    import DummyVereineDelete from "./dummyVereineDelete";

    export default {
        components: {
            DummyVereineDelete,
            DummyVereineEdit},
        name: "dummy-vereine",
        computed: {
            lv(){ return this.$store.state.realtime.landesverbaende['1']; },
            vereine(){
                let liste = [];
                if ( this.lv ) {
                    Object.keys(this.lv.vereine).forEach( (vereinsId) => {
                        liste.push({id: vereinsId, name: this.lv.vereine[vereinsId].name})
                    });
                    liste.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1);
                }
                return liste;
            }
        },
        data: () => ({
            currentObject: {
                id: null,
                name: null,
            }
        }),
        created(){
            if ( !this.lv ) {
                this.$store.dispatch('bindRealtimeDocument', {
                    collection: 'landesverbaende',
                    docId: '1',
                    storeField: 'landesverbaende.1',
                });
            }
        },
        methods: {
            back(){
                window.history.back();
            },
            editVerein(id){
                if ( id ) {
                    this.currentObject.id = id;
                    this.currentObject.name = this.lv.vereine[id].name;
                }
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'dummyVereineEdit';
                this.$router.push({path: p, query: q});
            },
        },
    }
</script>

<style scoped>
    .backButtonMob{position: fixed; right: 15px; bottom: 15px; z-index: 15}
    .listSmall{width: 300px}
</style>